import { DeltaCell } from "@/components/cinch/DeltaCell";

/**
 * Week-over-week movement chip for a Summary card.
 *
 * Feature-local composition of the DS `DeltaCell` chip variant — its only job is
 * picking the right magnitude format (deal *counts* aren't money) and rendering
 * nothing at all when there's no comparable prior week. A null delta means the
 * BE judged the comparison invalid: no snapshot yet, a card that didn't exist
 * last week, or a month/quarter boundary where a to-date figure has reset.
 * Rendering an em-dash in that case would read as "flat", which is wrong.
 */
export function WowChip({
  delta,
  kind = "money",
  className,
}: {
  delta: number | null | undefined;
  /** `count` formats as a plain integer (deal counts); `money` uses $K/$M. */
  kind?: "money" | "count";
  className?: string;
}) {
  if (delta == null) return null;
  return (
    <DeltaCell
      value={delta}
      chip
      className={className}
      // Counts are whole units, so anything non-zero is worth showing.
      threshold={kind === "count" ? 1 : 1}
      format={
        kind === "count"
          ? (n) => n.toLocaleString("en-US", { maximumFractionDigits: 0 })
          : undefined
      }
    />
  );
}
